"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _bs = require("react-icons/bs");

var _FilterChip = _interopRequireDefault(require("../FilterChip/FilterChip"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var FiltersSlide = function FiltersSlide(props) {
  var className = props.className,
      arrayFilters = props.arrayFilters,
      onDelete = props.onDelete;
  var containerSlide = (0, _react.useRef)();

  var handleRight = function handleRight() {
    containerSlide.current.scrollLeft += containerSlide.current.offsetWidth;
  };

  var handleLeft = function handleLeft() {
    containerSlide.current.scrollLeft -= containerSlide.current.offsetWidth;
  };

  return /*#__PURE__*/_react.default.createElement("div", {
    className: "".concat(className, " container-principal")
  }, /*#__PURE__*/_react.default.createElement("button", {
    type: "button",
    className: "arrows",
    onClick: handleLeft
  }, /*#__PURE__*/_react.default.createElement(_bs.BsChevronLeft, null)), /*#__PURE__*/_react.default.createElement("div", {
    className: "container-slide",
    ref: containerSlide
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "slide"
  }, arrayFilters && arrayFilters.map(function (chip, index) {
    return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, {
      key: index
    }, /*#__PURE__*/_react.default.createElement(_FilterChip.default, {
      content: chip.filter,
      onClick: function onClick() {
        return onDelete(chip);
      },
      tooltip: chip.tooltip
    }));
  }))), /*#__PURE__*/_react.default.createElement("button", {
    type: "button",
    className: "arrows",
    onClick: handleRight
  }, /*#__PURE__*/_react.default.createElement(_bs.BsChevronRight, null)));
};

FiltersSlide.propTypes = {
  className: _propTypes.default.string,
  arrayFilters: _propTypes.default.arrayOf(_propTypes.default.shape({
    filter: _propTypes.default.string,
    id: _propTypes.default.number,
    key: _propTypes.default.string,
    tooltip: _propTypes.default.string
  })).isRequired,
  onDelete: _propTypes.default.func.isRequired
};
var _default = FiltersSlide;
exports.default = _default;